import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Chip, Divider } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const SummaryComponent = ({ removeAddedVerification, addedVerificationsToLaunch }) => {
  const [t] = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Typography variant='h6'>{t('OfferEdit.Client.Verification.Summary')}</Typography>
      <Grid container direction='row'>
        {addedVerificationsToLaunch &&
          !!addedVerificationsToLaunch &&
          addedVerificationsToLaunch.map(ver => {
            return (
              <React.Fragment key={ver.documentId}>
                {ver.manualVerifications &&
                  !!ver.manualVerifications.length &&
                  ver.manualVerifications.map(({ entity, verificationData }) => {
                    return (
                      <React.Fragment key={entity.id}>
                        {verificationData && !!verificationData.length && (
                          <Grid item xs={12} key={entity.id} mb={1}>
                            <>
                              <strong>{`${entity.name || ''}: `}</strong>
                              {verificationData.map((item, idx) => (
                                <Chip
                                  key={item.verificationTypeId}
                                  label={item.verificationName}
                                  onDelete={() =>
                                    removeAddedVerification(idx, entity.id, entity.name, item.verificationName, ver.documentId, ver.siteId)
                                  }
                                  sx={{ marginRight: 1 }}
                                ></Chip>
                              ))}
                            </>
                          </Grid>
                        )}
                      </React.Fragment>
                    );
                  })}
              </React.Fragment>
            );
          })}
      </Grid>
    </>
  );
};

SummaryComponent.propTypes = {
  removeAddedVerification: PropTypes.func.isRequired,
  addedVerificationsToLaunch: PropTypes.array.isRequired
};

export default SummaryComponent;
